<template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-line" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">库内供应商构成</span>
        </div>
      </div>
      <div class="supplier-summary">
        <div class="summary-item">
          <span class="summary-label">在库供应商</span>
          <span class="summary-value">46</span>
          <span class="summary-unit">家</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-item pending">
          <span class="summary-label">待考察</span>
          <span class="summary-value">4</span>
          <span class="summary-unit">家</span>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {
        header: ['供应商类型', '在库', '待考察'],
        data: [
          ['招标代理机构', "<span class='supplier-count'>3</span>", '-'],
          ['专业分包-土方单位', "<span class='supplier-count'>2</span>", '-'],
          ['专业分包-门窗单位', "<span class='supplier-count'>1</span>", "<span class='pending-count'>2</span>"],
          ['专业分包-园林单位', "<span class='supplier-count'>4</span>", '-'],
          ['专业分包-智能化', "<span class='supplier-count'>1</span>", '-'],
          ['专业分包-幕墙单位', "<span class='supplier-count'>2</span>", "<span class='pending-count'>1</span>"],
          ['专业分包-消防单位', "<span class='supplier-count'>3</span>", "<span class='pending-count'>1</span>"],
          ['专业分包-保温单位', "<span class='supplier-count'>1</span>", '-'],
          ['劳务单位-零星工程', "<span class='supplier-count'>6</span>", '-'],
          ['劳务单位-土建工程', "<span class='supplier-count'>8</span>", '-'],
          ['劳务单位-装修工程', "<span class='supplier-count'>7</span>", '-'],
          ['材料单位-混凝土厂家', "<span class='supplier-count'>5</span>", '-'],
          ['临时材料库', "<span class='supplier-count'>3</span>", '-']
        ],
        rowNum: 6,
        waitTime: 1800,
        carousel: 'single',
        hoverPause: true,
        headerHeight: 32,
        headerBGC: 'rgba(20, 52, 83, 0.96)',
        oddRowBGC: 'rgba(10, 25, 47, 0.78)',
        evenRowBGC: 'rgba(20, 42, 68, 0.68)',
        index: false,
        columnWidth: [300, 70, 80],
        align: ['left', 'center', 'center']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$box-height: 410px;
#centerRight1 {
  padding: 16px;
  padding-top: 20px;
  height: $box-height;
  width: 100%;
  border-radius: 5px;
  .bg-color-black {
    position: relative;
    overflow: hidden;
    height: $box-height - 30px;
    border-radius: 10px;
    background: linear-gradient(180deg, rgba(13, 29, 53, 0.95), rgba(7, 15, 31, 0.96));
    box-shadow: inset 0 0 24px rgba(31, 180, 219, 0.07);
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 14px;
      right: 14px;
      height: 1px;
      background: linear-gradient(90deg, transparent, #2ddcda, transparent);
    }
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
    .dv-scr-board {
      width: calc(100% - 30px);
      height: 275px;
    }
  }
  .supplier-summary {
    height: 66px;
    margin: 7px 15px 8px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-top: 1px solid rgba(61, 197, 224, 0.18);
    border-bottom: 1px solid rgba(61, 197, 224, 0.18);
    background: rgba(21, 80, 107, 0.1);
    .summary-item {
      display: flex;
      align-items: baseline;
      gap: 3px;
      .summary-label {
        margin-right: 4px;
        color: #8394b5;
        font-size: 12px;
      }
      .summary-value {
        color: #55f0dc;
        font-size: 27px;
        font-weight: bold;
        text-shadow: 0 0 12px rgba(85, 240, 220, 0.45);
      }
      .summary-unit {
        color: #a9b6cd;
        font-size: 11px;
      }
      &.pending .summary-value {
        color: #ffbc57;
        text-shadow: 0 0 12px rgba(255, 188, 87, 0.4);
      }
    }
    .summary-divider {
      width: 1px;
      height: 30px;
      background: linear-gradient(transparent, rgba(86, 209, 226, 0.45), transparent);
    }
  }
  ::v-deep .supplier-count {
    color: #55f0dc;
    font-weight: bold;
  }
  ::v-deep .pending-count {
    display: inline-block;
    min-width: 18px;
    color: #ffbd5b;
    font-weight: bold;
    text-shadow: 0 0 8px rgba(255, 189, 91, 0.45);
  }
}
</style>
